import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="w-full bg-dark-900" data-id="element-65">
      {/* Image — full width, no overlays, no cropping */}
      <div className="w-full" data-id="element-66">
        <img src="https://cdn.magicpatterns.com/uploads/cTjz5fK3Wg8tG6wkhb4P4n/copia_imagen_recetas.png" alt="Recetas Caseras para Mascotas — Guía Digital Completa" className="w-full h-auto object-contain" data-id="element-67" />
      </div>

      {/* Content below the image */}
      <div className="container mx-auto px-4 md:px-6 py-10 md:py-16 text-center" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-69">
          <p className="text-lg md:text-2xl text-gray-300 mb-3 md:mb-6 font-light" data-id="element-70">
            Comida real para perros y gatos. <br data-id="element-71" />
            <strong className="text-earth-gold font-semibold" data-id="element-72">
              Más salud. Más vida.
            </strong>
          </p>
          <p className="text-gray-400 mb-6 md:mb-10 max-w-2xl mx-auto text-base md:text-lg" data-id="element-73">
            Una guía práctica con{' '}
            <strong className="text-white" data-id="element-74">180 recetas</strong> completas,
            sencillas y equilibradas, pensadas para cada etapa de su vida.
            Porque alimentarlos bien no debería ser complicado.
          </p>

          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-75">
            <span className="text-gray-500 line-through text-lg md:text-xl" data-id="element-76">
              24,99€
            </span>
            <span className="text-earth-amber font-bold text-2xl md:text-3xl" data-id="element-77">
              12,99€
            </span>
            <span className="bg-red-600 text-white text-xs font-bold py-1 px-2 rounded-md uppercase tracking-wide" data-id="element-78">
              -48% Oferta
            </span>
          </div>

          <motion.a href="#comprar" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-earth-amber hover:bg-earth-gold text-dark-900 font-bold text-base md:text-lg py-3 md:py-4 px-6 md:px-8 rounded-lg shadow-lg transition-colors cursor-pointer" data-id="element-79">
            Quiero la Guía Completa — 12,99€
          </motion.a>
          <p className="mt-3 md:mt-4 text-xs md:text-sm text-gray-500" data-id="element-80">
            Acceso inmediato • Descarga digital • Pago seguro
          </p>
        </motion.div>
      </div>
    </section>;
}